import { Container, TableBody, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { green, purple } from '@material-ui/core/colors';
import { React, useEffect, useState } from 'react';
import * as API from '../../api/index';
import Mpesa from '../../payments/mpesa/mpesa';
import ReactPaypal from '../../payments/paypal/paypal';
import { StyledPredictionsTable, PaymentBoxHeader, PaymentTitle, StyledBox, StyledHeading, StyledSection, StyledGamesBox, StyledParagraph, StyledPaymentBox, StyledPaymentPaper, StyledTableCell, StyledTableRow, StyledTableHead } from '../styles/global-style';
import { headers } from './vipheader';
import GamesTable from './vip_table';


const FixedMatches = () => {
    const [games, setGames] = useState([]);
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))
    const [subscribed, setSubscribed] = useState(false);


    useEffect(() => {
        getGames();
        getUser();
        document.title = 'Fixed Matches | Sure Fixed Matches'
    }, [])

    const getGames = async () => {
        try {
            const { data } = await API.VIPGames('FM')
            const match = data[0].games
            setGames(match)

        } catch (error) {
            console.log(error);
        }
    }

    const getUser = async () => {
        try {
            const username = user?.user.username
            const { data } = await API.fixedSubscribers(username)
            setSubscribed(data[0].fixed_matches)

        } catch (error) {
            console.log(error);
        }
    }

    return (
        <Container align='center'>
            <StyledBox align='justify'>
                <StyledHeading variant='h5' >Fixed Matches</StyledHeading>

                <StyledParagraph variant='caption'>
                    Tips predictions presents for you sure <b>Fixed Matches</b> coming up this week with their predictions. 
                    To view and place these sure tips in your bet <b>Book now</b> to stand a great chance to win big.
                </StyledParagraph>
            </StyledBox>
            <StyledSection>
                <StyledGamesBox>
                <GamesTable subscribed={subscribed} games={games} />
                </StyledGamesBox>
                <StyledPaymentPaper>
                    <StyledPaymentBox >
                        <PaymentBoxHeader variant='h5'>Book Now</PaymentBoxHeader>
                        <PaymentTitle mleft={10} textcolor={green[900]}>Pay with Mpesa</PaymentTitle>
                        <Mpesa price={10000} product={'fixed_matches'} />
                        <PaymentTitle mleft={10} textcolor={purple[900]}>Pay with PayPal</PaymentTitle>
                        <ReactPaypal price={100.0} product={'fixed_matches'} />
                    </StyledPaymentBox>
                </StyledPaymentPaper>
            </StyledSection>

            <StyledBox mt={5} align='justify'>
                <StyledParagraph variant='caption'>
                    {/* To access complete predictions for this Jackpot simply subscribe by making a payment of <b>$3 or Ksh. 300</b>.
                    <b>Alternatively,</b> you can join <b>VIP</b> which comes in hand with a free jackpot prediction of your choice. Happy Betting. */}
                </StyledParagraph>
            </StyledBox>
        </Container>
    );
};

export default FixedMatches;
